export class FcdStructure {
  public id: number;
  public siterecordId: number;
  public fcd: string;
}



// WEBPACK FOOTER //
// ./src/app/models/fcdStructure.model.ts